import React, { useEffect, useState } from 'react'
import styles from '../base/CommonSettings.module.scss';
import Select from '../../../common/Select.jsx'
import DashboardIconSelect from '../../../common/icon_select/DashboardIconSelect.lazy.jsx'
import ColorPicker from '../../../common/ColorPicker/DashboardColorPicker.jsx'
import { fetchJson } from '../../../../helpers/fetch.js';

import {
    task_status_options_path
} from '~/routes';

const CREATED_AT_OPTIONS = [
    'last_30_days', 
    'last_7_days', 
    'today', 
    'yesterday', 
    'this_month', 
    'last_month', 
    'this_quarter', 
    'last_quarter', 
    'this_year', 
    'last_year'
]

function TaskStatusWidgetSettingsRow({variables, index, updateVariableSetting, settingsVariables}) {
    const [statusOptions, setStatusOptions] = useState([]);

    useEffect(() => {
        const setDefs = async () => {
            const opts = await fetchJson(task_status_options_path());
            setStatusOptions(opts);
        }
        setDefs();
    }, [setStatusOptions]);

    return (
        <div className="w-100">
            <label className={styles['settings-option']}>
            {I18n.t("task_title")}
            <Select
                value={variables[index].task_title}
                options={(settingsVariables || []).map(v => ({value: v.title, label: v.title}))} 
                isMulti = {true}
                onChange={(v) => updateVariableSetting("task_title", index, v)}
            />
            </label>

            <label className={styles['settings-option']}>
            {I18n.t("created_at")}
            <Select
                value={variables[index].created_at}
                options={[{value: "", label: I18n.t("select_created_at")}, ...CREATED_AT_OPTIONS.map((i) => ({value: i, label: I18n.t(i, { scope: "date_range_presets" })}))]}
                onChange={(v) => updateVariableSetting("created_at", index, v)}
            />
            </label>
            <label className={styles['settings-option']}>
            {I18n.t("status")}
            <Select
                value={variables[index].status}
                options={statusOptions}
                onChange={(v) => updateVariableSetting("status", index, v)}
            />
            </label>
            <label className={styles['settings-option']}>
            {I18n.t("name_item")}
            <input
                type="text"
                className="form-control"
                name="name_item"
                maxLength={70}
                data-index={index}
                value={variables[index].name_item}
                onChange={(e) => updateVariableSetting("name_item", e.target.dataset.index, e.target.value)}
            />
            </label>
            <label className={styles['settings-option']}>
            <div style={{ width: "20%", paddingLeft: "0", marginTop: "1rem", display: "inline-block" }}>{I18n.t("image")}</div>
            <DashboardIconSelect
                value={variables[index].image}
                onChange={(v) => updateVariableSetting('image', index, v)}
            />
            </label>
            <label className={styles['settings-option']}>
            {I18n.t("background_color")}
            <ColorPicker
                value={variables[index].background_color}
                onChange={(v) => updateVariableSetting('background_color', index, v)}
            />
            </label>
        </div>

    )
}

export default TaskStatusWidgetSettingsRow;